import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';

import {
  creditCountSelector,
  setCreditCount,
  setFieldErrors,
  transactionTypeSelector,
} from 'features/creditManagement';
import Field from 'components/Field';
import Input from 'components/Input';
import styles from './ManageCreditCountField.module.scss';

function ManageCreditCountField() {
  const dispatch = useDispatch();

  const creditCount = useSelector(creditCountSelector);
  const valueType = useSelector(transactionTypeSelector);

  const handleCreditCountChange = useCallback(
    (e) => {
      batch(() => {
        dispatch(setFieldErrors(null));
        dispatch(setCreditCount(e.target.value));
      });
    },
    [dispatch]
  );

  return (
    <Field
      label={`Credits to ${valueType === 'ADD' ? 'Add' : 'Deduct'}:`}
      className={styles.inputHeader}
      name="addCreditCountField"
      prefixName="addCreditCountField"
    >
      <Input
        type="number"
        className={classNames(styles.entityInput, 'p-b-xxs')}
        onChange={handleCreditCountChange}
        value={creditCount}
        placeholder={'Credit Add Count'}
      />
    </Field>
  );
}

export default ManageCreditCountField;
